<template>
  <div class="form">
    <el-dialog :visible.sync="showDialog"
               :close-on-press-escape="false"
               :close-on-click-modal="false"
               custom-class="window"
               width="50%"
               top="5vh"
               :show-close="false"
               :title="$t('reportDialog.SendMail')">
      <el-form :model="emailData"
               ref="form"
               :rules="rule"
               style="width:90%;margin:0 auto"
               label-width="110px"
               label-position="right">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item :label="$t('reportDialog.To')"
                          prop="To"
                          required>
              <el-input v-model="emailData.To"
                        :placeholder="$t('reportDialog.To')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('reportDialog.Subject')"
                          prop="Subject"
                          required>
              <el-input v-model="emailData.Subject"
                        :placeholder="$t('reportDialog.Subject')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('reportDialog.Content')"
                          class="content">
              <el-input type="textarea"
                        v-model="emailData.Content"
                        :rows="4"
                        :placeholder="$t('reportDialog.Content')"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('reportDialog.Report')">
              <div class="row-link"
                   @click="download(id, fileName)">
                <div class="row-name">
                  {{fileName}}
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button size="small"
                   @click='closeDialog'>{{$t('reportDialog.Cancel')}}</el-button>
        <el-button size="small"
                   type="primary"
                   :disabled="disabled"
                   @click='send'>{{$t('reportDialog.Send')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { sendMailReport } from '@/api/config'
export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    fileName: {
      type: String,
      default: ''
    }
  },
  data () {
    const toAddress = (rule, value, callback) => {
      if (value) {
        value = value.trim()
        if (!this.$config.validEmail(value)) {
          return callback(new Error(this.$t('reportDialog.Youneedtoenteravalidemail')))
        } else {
          this.emailData.To = value.trim()
          callback()
        }
      } else {
        return callback(new Error(this.$t('reportDialog.Toisrequired')))
      }
    }
    return {
      disabled: false,
      emailData: {
        Content: '',
        Subject: '',
        To: '',
        UId: ''
      },
      rule: {
        To: [{
          trigger: 'blur',
          validator: toAddress
        }],
        Subject: [{
          required: true,
          message: this.$t('reportDialog.Subjectisrequired'),
          trigger: 'blur'
        }]
      }
    }
  },
  watch: {
    showDialog (to, from) {
      if (to) {
        this.disabled = false
      }
    }
  },
  mounted () {
  },
  methods: {
    send () {
      this.emailData.UId = this.id
      this.$refs['form'].validate((valid) => {
        if (valid) {
          var reg1 = new RegExp(';', 'gi')
          var emails = this.emailData.To.replace(reg1, ',').split(',')
          if (!this.$config.validEmails(emails, this.$t('reportDialog.Youneedtoenteravalidemail'))) {
            return
          }
          this.disabled = true
          sendMailReport(this.emailData).then(res => {
            this.btnLoading = false
            this.closeDialog()
          }).catch(err => {
            console.log(err)
            this.disabled = false
          })
        }
      })
    },
    closeDialog () {
      this.$refs['form'].clearValidate()
      this.$refs['form'].resetFields()
      this.$emit('closeDialog')
    },
    download (id, name) {
      this.$parent.downloadReport(id, name)
    }
  },
  computed: {
  }
}
</script>

<style scoped lang="scss">
.row-link {
  cursor: pointer;
  width: 100%;
  height: 100%;
  color: #409eff;
  text-decoration: none;
}

/deep/.el-form-item .el-form-item__label,
/deep/.el-form-item .el-form--label-top .el-form-item__label {
  padding: 0 12px 0 0;
  line-height: 40px;
}
</style>
